"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const React = require("react");
const utils_1 = require("../utils");
const strategies_1 = require("../strategies");
/**
 * Represents an arbiter recall component to load extension components.
 */
class ArbiterRecall extends React.Component {
    constructor(props) {
        super(props);
        this.mounted = false;
        this.setLoaded = () => this.mounted && this.setState({ loaded: true });
        this.setModules = (error, modules) => this.mounted &&
            this.setState({
                error,
                modules,
            });
        this.state = {
            loaded: false,
            modules: [],
        };
    }
    componentDidMount() {
        const _a = this.props, { async, strategy = async ? strategies_1.asyncStrategy : strategies_1.standardStrategy } = _a, options = tslib_1.__rest(_a, ["async", "strategy"]);
        this.mounted = true;
        strategy(options, this.setModules).then(this.setLoaded, this.setLoaded);
    }
    componentWillUnmount() {
        this.mounted = false;
    }
    render() {
        const { children } = this.props;
        const { loaded, modules, error } = this.state;
        if (utils_1.isfunc(children)) {
            return children(loaded, modules, error);
        }
        else if (loaded) {
            return children;
        }
        return false;
    }
}
exports.ArbiterRecall = ArbiterRecall;
